var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "step",
    {
      attrs: {
        title: _vm.title,
        id: _vm.id,
        description: _vm.description,
        component: _vm.component,
      },
    },
    [
      _vm.initialized
        ? _c(
            "div",
            { staticClass: "flex-grow flex flex-col pb-2" },
            [
              _c(
                "toolbar",
                [
                  _c(
                    "toolbar-tab-container",
                    [
                      _c(
                        "toolbar-tab",
                        {
                          attrs: { active: _vm.tab === "rules" },
                          on: {
                            click: function ($event) {
                              _vm.tab = "rules"
                            },
                          },
                        },
                        [_vm._v("\n          Enrichment Rules\n        ")]
                      ),
                      _vm._v(" "),
                      _c(
                        "toolbar-tab",
                        {
                          attrs: { active: _vm.tab === "results" },
                          on: {
                            click: function ($event) {
                              _vm.tab = "results"
                            },
                          },
                        },
                        [_vm._v("\n          Results\n        ")]
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("div", { staticClass: "flex-grow" }),
                  _vm._v(" "),
                  _vm.showCompare
                    ? _c(
                        "tooltip",
                        {
                          staticClass: "mr-2",
                          attrs: {
                            content: _vm.resultsToolTip,
                            "tooltip-width": "150px",
                          },
                        },
                        [
                          _c("action", {
                            staticClass: "ml",
                            attrs: { icon: "mdi mdi-open-in-new" },
                            on: {
                              click: function ($event) {
                                return _vm.openPopout()
                              },
                            },
                          }),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  !_vm.preventSkip
                    ? _c(
                        "btn",
                        {
                          staticClass: "mr-2",
                          on: {
                            click: function ($event) {
                              return _vm.skipEnrichments()
                            },
                          },
                        },
                        [_vm._v("\n        Skip Enrichments\n      ")]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _c("step-pager", { attrs: { disabled: !_vm.isValid } }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.tab === "rules",
                      expression: "tab === 'rules'",
                    },
                  ],
                  staticClass: "flex flex-col flex-grow",
                },
                [
                  _vm.editorReady
                    ? _c("ls-enrichment-editor", {
                        staticClass: "flex-grow",
                        attrs: {
                          domain: _vm.domain,
                          "api-root": _vm.lsUrl,
                          "verification-token": _vm.verificationToken,
                          jwt: _vm.token,
                          "enrichment-path": _vm.enrichmentPath,
                        },
                        domProps: {
                          mappedFields: _vm.lsMappedFields,
                          request: _vm.enrichmentRequest,
                        },
                        on: {
                          enrichmentsaved: _vm.onEnrichmentSaved,
                          enrichmentapply: _vm.onEnrichmentApply,
                          enrichmentdirty: _vm.onEnrichmentDirty,
                          enrichmentloaded: _vm.onEnrichmentLoaded,
                        },
                      })
                    : _vm._e(),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.tab === "results",
                      expression: "tab === 'results'",
                    },
                  ],
                  staticClass: "flex flex-col flex-grow pt-4",
                },
                [
                  _vm.showCompare
                    ? _c("compare", {
                        key: _vm.compareKey,
                        staticClass: "flex-grow",
                        attrs: {
                          leftDisplayName: "Golden",
                          rightDisplayName: "Enriched",
                          leftName: "Golden",
                          rightName: "Enriched",
                          compareKey: "LoanId",
                          sessionId: _vm.sessionId,
                          packageId: _vm.packageId,
                          isNew: true,
                          lsProps: _vm.lsProps,
                          tabProps: _vm.compareTabProps,
                          scratchApiRoot: _vm.parsedLsUrl,
                          compareUploadedFiles: true,
                          compareEndpoint: _vm.compareEndpoint,
                        },
                      })
                    : _vm._e(),
                ],
                1
              ),
            ],
            1
          )
        : _vm._e(),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }